import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseMilestone } from '../../data/types';

export type CaseMilestoneState = {
    milestones: CaseMilestone[],
}

export const useCaseMilestoneState = () => {
    const milestoneState = useSelector((state: RootState | any) => state.caseMilestones as CaseMilestoneState);
    return milestoneState;
}

// Define the initial state using that type
const initialState: CaseMilestoneState = {
    milestones: [],
}

export const caseMilestoneSlice = createSlice({
    name: 'caseMilestones',
    initialState: initialState,
    reducers: {
        setCaseMilestonesAction: (state, action: PayloadAction<CaseMilestone[]>) => {
            state.milestones = action.payload;
        },
        addOrReplaceCaseMilestoneAction: (state, action: PayloadAction<CaseMilestone>) => {
            const existingIndex = state.milestones.findIndex((milestone: CaseMilestone) => milestone?.milestoneId === action.payload.milestoneId);
            if (existingIndex >= 0) {
                state.milestones[existingIndex] = action.payload;
            } else {
                state.milestones.push(action.payload);
            }
        },
        deleteCaseMilestoneAction: (state, action: PayloadAction<string>) => {
            state.milestones = state.milestones.filter((x) => x.milestoneId !== action.payload);
        },
        deleteCaseMilestonesAction: (state, action: PayloadAction<string[]>) => {
            state.milestones = state.milestones.filter((x) => x.milestoneId && !action.payload.includes(x.milestoneId));
        },
    }
})

export const { addOrReplaceCaseMilestoneAction, setCaseMilestonesAction, deleteCaseMilestoneAction, deleteCaseMilestonesAction } = caseMilestoneSlice.actions;
export default caseMilestoneSlice.reducer;